import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import courseActions from '@redux/course/actions';
import { RootState } from '@redux/reducer';

const { fetchCourseDetailSeoAction, fetchCourseDetailAction, fetchCourseDetailGlancesAction } = courseActions;

const useBundleCourse = () => {
  const dispatch = useDispatch();
  const { courseDetailSeoState, courseDetailState } = useSelector((state: RootState) => ({
    courseDetailSeoState: state.Course.get('courseDetailSeoState'),
    courseDetailState: state.Course.get('courseDetailState'),
  }));

  const handleFetchCourseDetailSeo = (courseIdOrIdName: string) => {
    dispatch(fetchCourseDetailSeoAction.request({ courseIdOrIdName }));
  };

  const handleFetchCourseDetail = (courseIdOrIdName: string) => {
    dispatch(fetchCourseDetailAction.request({ courseIdOrIdName }));
  };

  const handleFetchCourseDetailGlance = (courseIdOrIdName: string) => {
    dispatch(fetchCourseDetailGlancesAction.request({ courseIdOrIdName }));
  };

  const handleResetCourseDetailSeo = () => {
    dispatch(fetchCourseDetailSeoAction.reset());
  };

  const handleResetCourseDetail = () => {
    dispatch(fetchCourseDetailAction.reset());
  };

  const {
    data: courseDetailSeoData,
    isLoading: isCourseDetailSeoLoading,
    isSuccess: isCourseDetailSeoSuccess,
    isError: isCourseDetailSeoError,
  } = courseDetailSeoState;

  const {
    data: courseDetailData,
    isLoading: isCourseDetailLoading,
    isSuccess: isCourseDetailSuccess,
    isError: isCourseDetailError,
  } = courseDetailState;

  const { courseDetailSeo, courseDetail } = useMemo(() => {
    return {
      courseDetailSeo: courseDetailSeoData,
      courseDetail: courseDetailData,
    };
  }, [courseDetailSeoData, courseDetailData]);

  return {
    courseDetailSeo,
    isCourseDetailSeoLoading,
    isCourseDetailSeoSuccess,
    isCourseDetailSeoError,
    courseDetail,
    isCourseDetailLoading,
    isCourseDetailSuccess,
    isCourseDetailError,
    handleFetchCourseDetailSeo,
    handleFetchCourseDetail,
    handleResetCourseDetailSeo,
    handleResetCourseDetail,
    handleFetchCourseDetailGlance,
  };
};

export default useBundleCourse;
